import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectIndicatorsFetched, {
	type SubjectIndicatorCountPayload,
	type SubjectIndicatorsFetchedAction,
} from '@Application/Indicators/Actions/subjectIndicatorsFetched';
import subjectIndicatorsFetchFailed, {
	type SubjectIndicatorsFetchFailedAction,
} from '@Application/Indicators/Actions/subjectIndicatorsFetchFailed';
import resolveIndicatorBasePath from '@Application/Indicators/resolveIndicatorBasePath';
import type FetchSubjectIndicators from '@Application/Indicators/Queries/FetchSubjectIndicators';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = SubjectIndicatorsFetchedAction | SubjectIndicatorsFetchFailedAction;

export default (query: FetchSubjectIndicators) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const counts = await get<SubjectIndicatorCountPayload[]>(
				`${resolveIndicatorBasePath(query.scope)}/subjects`,
			);

			const action = subjectIndicatorsFetched({ queryKey: query.queryKey, counts });
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectIndicatorsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
